"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotShieldOff = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotShieldOff = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M19.72 5.177a6.184 6.184 0 0 0-5.418.083C14.73 2.825 13.551 0 10.801 0 5.939.09-.095 5.523.55 11.512c-.751 3.456-1.12 7.634 1.503 10.196 2.254 2.217 5.11 1.984 7.702.932.73.222 1.498.286 2.254.188 2.969.684 6.087-1.736 8.311-3.682s4.734-5.14 4.659-8.716c-.09-3.923-2.563-5.245-5.26-5.253Z",
    opacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M6.667 6.661v9.931c0 8.664 5.111 16.482 13.333 20.074 3.825-1.67 6.976-4.255 9.253-7.414M3.334 3.333l25.919 25.919m7.414 7.415-7.414-7.415M15 3.874c6.374-1.255 12.408-.326 18.333 2.787v9.931a21.72 21.72 0 0 1-.599 5.075"
  }));
};
exports.SpotShieldOff = SpotShieldOff;
SpotShieldOff.displayName = "SpotShieldOff";